import { automationApi } from 'nove8/api'
import {
  DEFAULT_WOOFY_CHAT_API_VERSION,
  ProcessingKey,
  TWoofyChatApiVersion,
} from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const storeWoofyCreative = async ({
  creativeId,
  leadId,
  apiVersion = DEFAULT_WOOFY_CHAT_API_VERSION,
}: {
  creativeId: string
  leadId: string
  apiVersion?: TWoofyChatApiVersion
}): Promise<void> => {
  useZustandStore
    .getState()
    .startProcessing(ProcessingKey.AUTOMATION_WOOFY_STORE_CREATIVE)

  try {
    const result = await automationApi.storeWoofyCreative({
      creativeId,
      leadId,
      apiVersion,
    })

    if (!result.success) {
      throw new Error('storeWoofyCreative failed')
    }
  } finally {
    useZustandStore
      .getState()
      .stopProcessing(ProcessingKey.AUTOMATION_WOOFY_STORE_CREATIVE)
  }
}
